import { Component, Injector, OnInit, ElementRef, ViewChild } from '@angular/core';
import { inject } from '@angular/core';
import { Database, ref, set, child, get, onValue, update } from "@angular/fire/database";
import { BaseComponent } from 'src/app/shared/baseComponent';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "@angular/fire/auth";

const VALID_DOMAINS = ['cellpodium.com', 's5-tech.com']

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent extends BaseComponent implements OnInit {
  database = inject(Database);
  isAuthenticatedWithFirebase = false
  private googleAuthProvider = new GoogleAuthProvider();

  events: any = []
  eventsArray: any = []
  eventsArrayDisplay: any = []
  type: string = 'all'
  scenario: string = 'all'
  player: string = 'all'
  minutes = '30'
  currentDate = new Date();

  constructor(injector: Injector) {
    super(injector)
  }

  async ngOnInit(): Promise<void> {
    this.isAuthenticatedWithFirebase = getAuth().currentUser != null
    if (this.isAuthenticatedWithFirebase) {
      await this.onSuccessfullLogin()
    }
  }

  async signInWithGoogle() {
    const auth = getAuth();
    try {
      const credential = await signInWithPopup(auth, this.googleAuthProvider)
      if (credential.user.email == null) {
        await auth.signOut();
        return
      }
      const domain = credential.user?.email.split('@')[1]?.toLowerCase();
      if (!VALID_DOMAINS.includes(domain)) {
        await auth.signOut();
        return
      }
      this.isAuthenticatedWithFirebase = true
      await this.onSuccessfullLogin()
    } catch (error: any) {
      alert((error as Error).message)
    }
  }
  private async onSuccessfullLogin() {
    await this.getData()
  }

  async getData() {
    this.loader.show()
    const avatarsRef = ref(this.database, 'events');
    const snapshot = await get(avatarsRef);
    if (snapshot.exists()) {
      this.events = snapshot.val();
      this.eventsArray = this.collectionToArrayFB(this.events)
      this.eventsArray.sort((a: any, b: any) => {
        const dateA = new Date(a.timestamp);
        const dateB = new Date(b.timestamp);
        return dateB.getTime() - dateA.getTime(); // For descending order
      });
      this.eventsArray.forEach((item: any) => {

        item.datetime = this.convertTimestamp(item.timestamp)
      })
      this.eventsArrayDisplay = this.eventsArray
    }
    this.loader.hide()
  }



  async deleteEvent(event: any) {
    this.loader.show()
    const eventRef = ref(this.database, 'events/' + event.property);
    set(eventRef, null)
    this.getData()
    this.loader.hide()
  }

  filter() {

    this.eventsArrayDisplay = this.eventsArray.filter((event: any) =>
      (this.type === "all" || this.type === "" || event.type === this.type) &&
      (this.scenario === "all" || this.scenario === "" || event.scenarioid === this.scenario) &&
      (this.player === "all" || this.player === "" || event.playerid === this.player))
  }

  clear() {
    this.type = 'all'
    this.scenario = 'all'
    this.player = 'all'
    this.eventsArrayDisplay = this.eventsArray
  }
  deleteAll() {
    this.eventsArray.forEach((item: any) => {
      var differenceInMinutes = this.minutesBeforeNow(item.timestamp);
      let mp = Number(this.minutes);
      
      if (differenceInMinutes > mp) {
        this.deleteEvent(item);
      }
    });
    this.toast.success("Please refresh the screen to see the results");
  }

  minutesBeforeNow(timestamp: number): number {
    // Create a date object from the timestamp
    const timestampDate: Date = new Date(timestamp);

    // Get the current date
    const now: Date = new Date();

    // Calculate the difference in minutes
    const differenceInMinutes: number = (now.getTime() - timestampDate.getTime()) / 60000;

    return differenceInMinutes;
  }

  async refresh() {
    this.loader.show()
    await this.getData()
    this.loader.hide()
  }

}
